import { cloneElement, FunctionComponentElement, HTMLAttributes, ReactElement, ReactNode } from 'react';
import { joinClassNames } from '../../utils';
import { BaseIconProps } from '../Graphics/Icons/BaseIcon';
import { IconProps } from '../Graphics/Icons/_deprecated/Icon';
import { TagVariant } from './enums';
import styles from './styles.module.scss';

// Rfq status tags have font-weight 500
const RFQ_STATUSES = [
  TagVariant.RfqE1Created,
  TagVariant.RfqStatusApproved,
  TagVariant.RfqStatusNoResponse,
  TagVariant.RfqStatusQuoted,
  TagVariant.RfqStatusQuoting,
  TagVariant.RfqStatusNotQuoting,
  TagVariant.RfqHasDocs,
  TagVariant.RfqDocsDownloaded,
  TagVariant.RfqDocsObsolete,
  TagVariant.RfqDocsHardCopy,
  TagVariant.Error,
];

const isRfqStatusTag = (variant: TagVariant): boolean => RFQ_STATUSES.includes(variant);

const WATCHLIST_STATUSES = [
  TagVariant.WatchlistInterested,
  TagVariant.WatchlistQuoting,
  TagVariant.WatchlistQuoted,
];

const isWatchlistStatusTag = (variant: TagVariant): boolean => WATCHLIST_STATUSES.includes(variant);

export type TagProps = HTMLAttributes<HTMLSpanElement> & {
  /**
   * Enum, TagVariant(`TagVariant.Practical200`, etc...)
   */
  variant: TagVariant;
  /**
   * @deprecated Use `children` instead
   */
  text?: string;
  children?: ReactNode;
  icon?: FunctionComponentElement<BaseIconProps | IconProps>;
};

export const Tag = ({ variant, text, children, icon, className, ...props }: TagProps): ReactElement => {
  const iconClassNames = joinClassNames(styles.icon, icon?.props.className);
  return (
    <span
      className={joinClassNames(
        styles.tag,
        styles[variant],
        isRfqStatusTag(variant) && styles.rfqStatus,
        isWatchlistStatusTag(variant) && styles.watchlist,
        className
      )}
      {...props}
    >
      {icon && cloneElement(icon, { className: iconClassNames })}
      {text ?? children}
    </span>
  );
};

Tag.displayName = 'Tag';
